import React from "react";
import "animate.css";
import useInViewport from "../hook/useInViewPort";

interface FadeInSectionProps {
    children: React.ReactNode;
    animation?: string;
    treshold?: number;
    delay?: string;
    speed?: string;
    className?: string;
}

const FadeInSection: React.FC<FadeInSectionProps> = ({className= "", children, animation = "animate__fadeInUp", treshold = 0.3, speed= "", delay = "" }) => {
    const { ref, isVisible } = useInViewport(treshold);

    return (
        <div
            ref={ref}
            className={`${className} animate__animated ${isVisible ? `${animation} ${speed} ${delay}` : "opacity-0"}`}
            style={{ transition: "opacity 0.6s ease-out" }}
        >
            {children}
        </div>
    );
};

export default FadeInSection;
